import { useGetProductTemplateInfos } from "api/api-hooks/product-templates-hooks";
import { DropdownChangeParams } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import React, { useEffect, useState } from "react";
import { T } from "services/lang/LanguageService";

interface IProductTemplateDropdownProps {
  value?: ProdTemplateDropdownItem[];
  onChange?: (e: DropdownChangeParams) => void;
}

export interface ProdTemplateDropdownItem {
  refName: string;
  id: number;
  label: string;
}

export function ProductTemplateMultiselect(props: IProductTemplateDropdownProps) {
  const [allSelections, setAllSelections] = useState<ProdTemplateDropdownItem[]>([]);

  const query = useGetProductTemplateInfos();
  useEffect(() => {
    if (query.data) {
      const selections = query.data.map(it => ({
        id: it.id,
        label: it.displayName,
        refName: it.refName,
      }));
      setAllSelections(selections);
    }
  }, [query.data]);

  let placeholderText;
  if (query.error) {
    placeholderText = T("error.product-template-selection-error");
  } else if (query.isLoading && !query.error) {
    placeholderText = T("message.product-templates-loading");
  } else {
    placeholderText = T("message.select-product-template");
  }

  return (
    <>
      {query.error && <span>{T("error.product-template-selection-error")}</span>}

      {query.isLoading && !query.error && <span>{T("message.product-templates-loading")}</span>}

      {query.isSuccess && (
        <MultiSelect
          placeholder={placeholderText}
          value={props.value || []}
          options={allSelections}
          className="h-max w-full"
          filter
          filterMatchMode="contains"
          onChange={props.onChange}
        />
      )}
    </>
  );
}
